import React, { useEffect, useState } from 'react';
import { FaTwitch } from 'react-icons/fa';

const TWITCH_USER = 'seedsmash';

const TwitchLiveLink = () => {
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await fetch('/api/twitch-live');
        const data = await res.json();
        setIsLive(data.is_live);
      } catch (err) {
        console.error(err);
        setIsLive(false);
      }
    };
  
    fetchStatus();
  }, []);

  return (
    <a
      href="https://www.twitch.tv/seedsmash"
      target="_blank"
      rel="noreferrer"
      className={`flex-shrink-0 z-10 px-4 py-2 flex items-center duration-200 ease-in-out ${
        isLive ? 'text-pink-200 hover:text-pink-300' : 'hover:text-gray-200'
      }`}
    >
      <span className="flex items-center space-x-2">
        <FaTwitch />
        <span>{isLive === null ? '' : isLive ? 'Currently Live!' : 'Twitch Channel'}</span>
      </span>
    </a>
  );
};

export default TwitchLiveLink;